module.exports = __webpack_public_path__ + "img/2.8074049e.png";